module.exports = __webpack_public_path__ + "static/cheese-4-7733ae541cfc66fab6bf6f4515d24e8a.png";